import React, { useContext } from "react";
import { Context } from "../../../store/AppContext";
import { calcularSaldoDtProvidencia } from "../calcularSaldoDtProvidencia";

const InformacionCliente = () => {
	const { store, actions } = useContext(Context);

	const CalculoSaldo = (variable) => {
		const objeto = store.infoClienteDtProvidencia;
		
		if (!objeto) {
			return variable === "SaldoDeberia2023" ? "0" : "Pagado";
		}

		const { saldo, mesesPendientes } = calcularSaldoDtProvidencia(objeto);

		// Si se solicita solo la cantidad de meses pendientes
		if (variable === "SaldoDeberia2023") {
			return mesesPendientes.toString();
		}

		// Retornar el saldo calculado
		return saldo;
	};

	return (
		<div className='cell small-6'>
			<div className='card' style={{ width: "99%" }}>
				<div className='card-divider no-print'>
					<h4>Informacion de Cliente</h4>
				</div>
				<div className='card-section'>
					{store.infoClienteDtProvidencia != null ? (
						<ul className='no-bullet'>
							<li>Id:{store.infoClienteDtProvidencia.id}</li>
							<li>Razon Social: {store.infoClienteDtProvidencia.razon}</li>
							<li>Rut Empresa: {store.infoClienteDtProvidencia.rut}</li>
							<li>
								Nombre de Representante: {store.infoClienteDtProvidencia.representante}
							</li>
							<li>Rut Representante: {store.infoClienteDtProvidencia.rutRepresentante}</li>
							<li>
								Fecha Contratacion: {store.infoClienteDtProvidencia.fechaContratacion}
							</li>
							<li className='no-print'>
								Contrato Actualizado: {store.infoClienteDtProvidencia.contratoActualizado}
							</li>
							<li className='no-print'>Dicom: {store.infoClienteDtProvidencia.dicom}</li>
							<li className='no-print'>
								Vigente: {store.infoClienteDtProvidencia.vigente}
							</li>
							<li>Patente: {store.infoClienteDtProvidencia.patente}</li>
							<li>Correo: {store.infoClienteDtProvidencia.correo}</li>
							<li>Fono: {store.infoClienteDtProvidencia.fono}</li>
							<li>
								Meses Pagados Sist. Nuevo:{" "}
								{store.infoClienteDtProvidencia.mesesPagados2023} (
								{CalculoSaldo("SaldoDeberia2023")})
							</li>
							<li>Saldo Total: ${CalculoSaldo()}</li>
						</ul>
					) : null}
				</div>
			</div>
		</div>
	);
};

export default InformacionCliente;
